import { render, staticRenderFns } from "./bottomLeft.vue?vue&type=template&id=58d97378&scoped=true&"
import script from "./bottomLeft.vue?vue&type=script&lang=js&"
export * from "./bottomLeft.vue?vue&type=script&lang=js&"
import style0 from "./bottomLeft.vue?vue&type=style&index=0&id=58d97378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d97378",
  null
  
)

export default component.exports